/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Knowledge_Assistants_Architect_Output9Inputs */

const en_svc_rag_knowledge_assistants_architect_output9 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RAG architecture spec`)
};

const ar_svc_rag_knowledge_assistants_architect_output9 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مواصفة بنية RAG`)
};

const bn_svc_rag_knowledge_assistants_architect_output9 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RAG আর্কিটেকচার স্পেসিফিকেশন`)
};

const de_svc_rag_knowledge_assistants_architect_output9 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RAG-Architekturspezifikation`)
};

const es_svc_rag_knowledge_assistants_architect_output9 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Especificación de arquitectura RAG`)
};

const fr_svc_rag_knowledge_assistants_architect_output9 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spécification d'architecture RAG`)
};

const pt_svc_rag_knowledge_assistants_architect_output9 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Especificação de arquitetura RAG`)
};

const zh_svc_rag_knowledge_assistants_architect_output9 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RAG 架构规范`)
};

const tr_svc_rag_knowledge_assistants_architect_output9 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RAG mimarisi şartnamesi`)
};

const ru_svc_rag_knowledge_assistants_architect_output9 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спецификация RAG-архитектуры`)
};

const pl_svc_rag_knowledge_assistants_architect_output9 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Specyfikacja architektury RAG`)
};

/**
* | output |
* | --- |
* | "RAG architecture spec" |
*
* @param {Svc_Rag_Knowledge_Assistants_Architect_Output9Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_rag_knowledge_assistants_architect_output9 = /** @type {((inputs?: Svc_Rag_Knowledge_Assistants_Architect_Output9Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Knowledge_Assistants_Architect_Output9Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_rag_knowledge_assistants_architect_output9(inputs)
	if (locale === "bn") return bn_svc_rag_knowledge_assistants_architect_output9(inputs)
	if (locale === "de") return de_svc_rag_knowledge_assistants_architect_output9(inputs)
	if (locale === "es") return es_svc_rag_knowledge_assistants_architect_output9(inputs)
	if (locale === "fr") return fr_svc_rag_knowledge_assistants_architect_output9(inputs)
	if (locale === "pt") return pt_svc_rag_knowledge_assistants_architect_output9(inputs)
	if (locale === "zh") return zh_svc_rag_knowledge_assistants_architect_output9(inputs)
	if (locale === "tr") return tr_svc_rag_knowledge_assistants_architect_output9(inputs)
	if (locale === "ru") return ru_svc_rag_knowledge_assistants_architect_output9(inputs)
	if (locale === "pl") return pl_svc_rag_knowledge_assistants_architect_output9(inputs)
	return en_svc_rag_knowledge_assistants_architect_output9(inputs)
});
export { svc_rag_knowledge_assistants_architect_output9 as "svc_rag-knowledge-assistants_ARCHITECT_output" }